<div id="<%= dom_id(article) %>" class="flex flex-col sm:flex-row justify-between items-center pb-5 sm:pb-0">
  <div class="p-4 border rounded mb-4 flex-grow">
    <h2 class="text-xl font-bold">
      <%= link_to article.title, article, class: "text-blue-600 hover:underline" %>
      <span id="<%= dom_id(article, :comments_count) %>" class="text-gray-500 text-sm font-normal ml-2">
        (<%= pluralize(article.comments.size, "comment") %>)
      </span>
    </h2>
    <p class="text-gray-700 mt-2"><%= truncate(article.body, length: 100) %></p>
  </div>
  <div class="w-full sm:w-auto flex flex-col sm:flex-row space-x-2 space-y-2">
    <%= link_to "Show", article, class: "w-full sm:w-auto text-center rounded-md px-3.5 py-2.5 bg-gray-100 hover:bg-gray-50 inline-block font-medium" %>
    <%= link_to "Edit", edit_article_path(article), class: "w-full sm:w-auto text-center rounded-md px-3.5 py-2.5 bg-gray-100 hover:bg-gray-50 inline-block font-medium" %>
    <%= button_to "Destroy", article, method: :delete, class: "w-full sm:w-auto rounded-md px-3.5 py-2.5 text-white bg-red-600 hover:bg-red-500 font-medium cursor-pointer", data: { turbo_confirm: "Are you sure?" } %>
  </div>
</div>
